import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialsSharedModule } from '../materials-shared/materials-shared.module';

import { EmailComposerComponent } from './email-composer/email-composer.component';
import { CalculatorComponent } from './calculator/calculator.component';
import { DisplayRoundListComponent } from './display-round-list/display-round-list.component';
import { OkCancelDialogComponent } from './ok-cancel-dialog/ok-cancel-dialog.component';
import { LoadingComponent } from './loading/loading.component';
import { NewEventDialogComponent } from './new-event-dialog/new-event-dialog.component';
import { GroupByPipe } from '../../pipes/group-by';
import { StripePaymentComponent } from '../../components/stripe-payment/stripe-payment.component';
import { AdminEventContextMenuComponent } from './admin-event-context-menu/admin-event-context-menu.component';
import { EventContextMenuComponent } from './event-context-menu/event-context-menu.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { HandicapRoundsComponent } from './handicap-rounds/handicap-rounds.component';
import { PostScoreDialogComponent } from './post-score-dialog/post-score-dialog.component';
import { HandicapCardComponent } from './handicap-card/handicap-card.component';
import { NoCommaPipe } from '../../pipes/no-comma';
import { SelectDateDialogComponent } from './select-date-dialog/select-date-dialog.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { InlineEditComponent } from './inline-edit/inline-edit.component';
import { BillingComponent } from './billing/billing.component';
import { AdjustUsgaScoreDialogComponent } from './adjust-usga-score-dialog/adjust-usga-score-dialog.component';
import { AdjustPlayerIndexDialogComponent } from './adjust-player-index-dialog/adjust-player-index-dialog.component';
import { UploadPointsDialogComponent } from 'src/app/modules/shared/upload-points-dialog/upload-points-dialog.component';
import { SetPayoutDialogComponent } from './set-payout-dialog/set-payout-dialog.component';
import { AffiliatesAdsComponent } from './affiliates-ads/affiliates-ads.component';
import { ProcessStatusDialogComponent } from './process-status-dialog/process-status-dialog.component';
import { CreateEventDialogComponent } from './create-event-dialog/create-event-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialsSharedModule,
    CKEditorModule
  ],
  declarations: [
    EmailComposerComponent,
    CalculatorComponent,
    DisplayRoundListComponent,
    OkCancelDialogComponent,
    NewEventDialogComponent,
    LoadingComponent,
    GroupByPipe,
    NoCommaPipe,
    StripePaymentComponent,
    AdminEventContextMenuComponent,
    EventContextMenuComponent,
    UploadFileComponent,
    HandicapRoundsComponent,
    PostScoreDialogComponent,
    HandicapCardComponent,
    SelectDateDialogComponent,
    InlineEditComponent,
    BillingComponent,
    AdjustUsgaScoreDialogComponent,
    AdjustPlayerIndexDialogComponent,
    UploadPointsDialogComponent,
    SetPayoutDialogComponent,
    AffiliatesAdsComponent,
    ProcessStatusDialogComponent,
    CreateEventDialogComponent
  ],
  exports: [
    EmailComposerComponent,
    CalculatorComponent,
    DisplayRoundListComponent,
    OkCancelDialogComponent,
    NewEventDialogComponent,
    LoadingComponent,
    GroupByPipe,
    NoCommaPipe,
    StripePaymentComponent,
    MaterialsSharedModule,
    HandicapRoundsComponent,
    PostScoreDialogComponent,
    InlineEditComponent,
    BillingComponent,
    AdjustUsgaScoreDialogComponent,
    AdjustPlayerIndexDialogComponent,
    AffiliatesAdsComponent,
    ProcessStatusDialogComponent,
    CreateEventDialogComponent
  ],
})
export class SharedModule { }
